import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import { CalendarDays, MapPin, ArrowRight, ExternalLink } from "lucide-react";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/events")
      .then(r => setEvents(r.data || []))
      .finally(() => setLoading(false));
  }, []);
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = useMemo(() =>
    events.filter(e => (e.active !== false) && (!e.date || e.date >= today)),
    [events, today]
  );
  return (
    <>
      <PageHeader eyebrow="What's on" title="Events" sub="Showcases, community performances and special one-off gatherings from 2RightFeet." />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="events-grid">
        {loading && <div className="col-span-full text-center py-20 text-zinc-500">Loading events…</div>}
        {!loading && upcoming.map(e => (
          <Link
            to={`/events/${e.id}`}
            key={e.id}
            className="card-surface overflow-hidden card-hover group"
            data-testid={`event-${e.id}`}
          >
            {e.image && <img src={e.image} alt={e.caption || "Event"} className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500" />}
            <div className="p-6">
              <div className="eyebrow mb-2 flex items-center gap-2">
                <CalendarDays size={12}/>{e.date || "TBA"}
                {e.location && <><span className="text-zinc-600">·</span><MapPin size={12}/>{e.location}</>}
              </div>
              <h3 className="font-display text-2xl uppercase text-white">{e.caption || "Untitled event"}</h3>
              {e.description && <p className="text-zinc-400 text-sm mt-3 line-clamp-3">{e.description}</p>}
              <div className="mt-4 flex justify-between items-center border-t border-white/10 pt-4">
                <div className="font-display text-xl">{e.hosting === "external" && !(e.price > 0) ? <span className="text-xs text-zinc-500 uppercase tracking-widest">Hosted by {e.host_name || "partner"}</span> : (e.price > 0 ? `$${e.price}` : "Free")}</div>
                <span className="text-red-500 text-xs uppercase tracking-widest inline-flex items-center gap-1">{e.hosting === "external" ? <>Event page <ExternalLink size={12}/></> : <>View <ArrowRight size={12}/></>}</span>
              </div>
            </div>
          </Link>
        ))}
        {!loading && upcoming.length === 0 && (
          <div className="col-span-full text-zinc-500 text-center py-20" data-testid="events-empty">
            No upcoming events.
          </div>
        )}
      </div>
    </>
  );
}
